<template>
  <van-nav-bar
    :title="title"
    left-text="返回"
    left-arrow
    :fixed="true"
    :border="true"
    @click-left="onClickLeft"
  >
    <template #right>
      <van-icon name="replay" size="18" @click="refresh" />
    </template>
  </van-nav-bar>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  watch: {
    $route: {
      handler(to, from) {
        this.title = to.meta.title;

        if (
          to &&
          from &&
          !from.path.includes("qrcodeScan") &&
          !from.path.includes("/productDetail") &&
          !from.path.includes("/analysis/orderList")
        ) {
          const preRoute = { path: from.path, query: from.query };

          localStorage.setItem("preRoute", JSON.stringify(preRoute));
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  methods: {
    refresh() {
      location.reload();
    },
    onClickLeft() {
      debugger;
      if (this.$route.path.includes("/productDetail")) {
        let preRoute = JSON.parse(
          localStorage.getItem("productDetail-preRoute") || ""
        );
        if (preRoute) {
          let path = preRoute.path;
          let query = Object.assign({}, preRoute.query, this.$route.query);

          this.$router.push({ path, query });
        } else {
          this.$router.back();
        }
        return;
      }
      if (this.$route.path.includes("/analysis/orderDetail")) {
        this.$router.push(
          "/analysis/orderList/" + localStorage.getItem("productId")
        );
        return;
      }

      if (
        this.$route.path.includes("/analysis/orderList") ||
        this.$route.path.includes("/product/category")
      ) {
        let preRoute = JSON.parse(localStorage.getItem("preRoute") || "");
        if (preRoute) {
          let path = preRoute.path;
          let query = preRoute.query;
          this.$router.push({ path, query });
        } else {
          this.$router.back();
        }
        return;
      }
      if (this.$route.meta.prev) {
        this.$router.replace(this.$route.meta.prev);
        return;
      }
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped></style>
